import React from 'react';
import './index.css';
import gallery from '../../assets/gallery/gallery.png';
import gallery1 from '../../assets/gallery/gallery1.png';
import gallery2 from '../../assets/gallery/gallery2.png';
import gallery3 from '../../assets/gallery/gallery3.png';
import gallery4 from '../../assets/gallery/gallery4.png';
import gallery5 from '../../assets/gallery/gallery5.png';
import gallery6 from '../../assets/gallery/gallery6.png';
import gallery7 from '../../assets/gallery/gallery7.png';
import gallery8 from '../../assets/gallery/gallery8.png';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import BookTrialClass from '../../components/Classes';

const GallerySection = () => {
  return (
    <>
      <Header />
      <div className="container-fluid d-flex align-items-center flex-column">
        <h3>OUR GYM Gallery</h3>
        <p>
          Find Best GYM in your City. team of committed & best Caring trainers are striving to empower individuals to a
          <br />
          better healthier lifestyle. We will work within our Code of Values to ensure that everyone we train will move
          <br />
          closer to becoming the person they want to become and achieving the goals they want to achieve.
        </p>
      </div>
      <div className="containers">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery} className="img-fluid gallery-img" alt="Gallery Image 1" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery1} className="img-fluid gallery-img" alt="Gallery Image 2" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery2} className="img-fluid gallery-img" alt="Gallery Image 3" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery3} className="img-fluid gallery-img" alt="Gallery Image 4" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery4} className="img-fluid gallery-img" alt="Gallery Image 5" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery5} className="img-fluid gallery-img" alt="Gallery Image 6" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery6} className="img-fluid gallery-img" alt="Gallery Image 7" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery7} className="img-fluid gallery-img" alt="Gallery Image 8" />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <img src={gallery8} className="img-fluid gallery-img" alt="Gallery Image 9" />
          </div>
        </div>
      </div>
      <div className='marginLR'>
      <BookTrialClass/>
      </div>
      <Footer/>
    </>
  );
};

export default GallerySection;
